module.exports = __webpack_public_path__ + "media/country_flags/mt-c29dbf0a.png";